// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HLu2p","name":"styles_name__pd91V","phone":"styles_phone__-J6r-"};